import { useEffect, useState } from 'react';
import isEqual from 'lodash.isequal';
import {
    Box,
    Flex,
} from '@theme-ui/components';
import { Field } from '~/Forms';
import { Form, Formik } from 'formik';
import { Icon } from 'assets/Icon';

const fieldWrapStyles = {
    minWidth: [null, '428px'],
    width: ['100%','100%','100%','100%','auto'],
    mx: 2,
    color: 'black',   
};

const selectStyles = {
    py: '12px',
    color: 'black',
}

export const SubmitListener = ({ values, initialValues, submitForm, ...props }) => {
    const [lastValues, setLastValues] = useState(values);

    useEffect(() => {
        const valuesEqualLastValues = isEqual(lastValues, values);
        const valuesEqualInitialValues = values === initialValues;

        if (!valuesEqualLastValues) {
            setLastValues(values);
        }

        if (!valuesEqualLastValues && !valuesEqualInitialValues) {
            submitForm();
        }
    }, [
        lastValues,
        values,
        initialValues,
        submitForm
    ]);

    return null;
};

export const Filters = ({ handleSubmit, formRef, ...props }) => {
    return (
        <Formik
            enableReinitialize
            innerRef={formRef}
            initialValues={{
                type: '',
                stage: '',
                category: '',
                sortBy: ''
            }}
            onSubmit={handleSubmit}
        >
            {({ values, initialValues, submitForm }) => (
                <Form>
                    <Flex>
                        <Flex mx="auto" sx={{ justifyContent: 'center', alignItems: 'center', position: 'relative', width: ['95%', 'auto'] }}>
                            <Box sx={fieldWrapStyles}>
                                <Field name="search" showLabel={false} field="input" groupMb={0} sx={selectStyles} placeholder="Search Industry" />
                            </Box>
                            <Icon icon="search" color="black" sx={{position: 'absolute', right: 30, top: '40%'}} />
                        </Flex>
                    </Flex>
                    <SubmitListener values={values} initialValues={initialValues} submitForm={submitForm} />
                </Form>
            )}
        </Formik>
    );
};
